import { Navigate } from 'react-router-dom';

function Login({ auth }) {
  // If already authenticated, redirect to home
  if (auth.isAuthenticated) {
    return <Navigate to="/" />;
  }

  return (
    <div>
      <h1>Login</h1>
      <button onClick={() => auth.signinRedirect()}>
        Sign in here
      </button>
    </div>
  );
}

export default Login;